<template>
  <!-- 种草 -->
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202407/03/01.jpg" />
      <div class="rule" @click="$refs.rulesRef.open()"></div>
      <div class="add-sales" @click="addSalesSupport"></div>
      <div class="copy-topic-01" @click="copyText('#OK保')"></div>
      <div class="copy-topic-02" @click="copyText('#OK保app')"></div>
      <div class="copy-topic-03" @click="copyText('#OK保保险')"></div>
    </div>

    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>

    <!-- 添加销售支持 -->
    <addSalesSupportPopup ref="addSalesSupportRef"></addSalesSupportPopup>
  </div>
</template>

<script>
import activityRules from '@/components/okActivity/rulePopup';
import addSalesSupportPopup from '@/components/okActivity/addSalesSupportPopup';

export default {
  components: {
    activityRules,
    addSalesSupportPopup
  },

  created() {
    this.preview = this.$route.query.preview ? true : false;
    if (this.$route.query.preview) return;
    this.getUserStatus();
  },

  data() {
    return {
      preview: false,
      userType: null,
      isSus: null,
      ruleText: '<h1 style=\"text-align:center;font-size: 22px;\">规则详情</h1><h2 style="margin-top: 10px;">一、活动时间</h2><p>2024年7月1日-2024年7月31日</p><p><br/></p><h2><span>二、OK保种草达人活动</span></h2><h3><span>（一）活动对象</span></h3><p><span>OK保已注册用户</span></p><p><br></p><h3><span>（二）活动内容</span></h3><p><span>带话题#OK保，在小红书或抖音上，发帖分享OK保相关内容(图片、文字、视频形式皆可)</span></p><p><span>发帖满3篇（或曝光量满1000）威露士洗衣液</span></p><p><span>发帖满5篇（或曝光量满2000）午睡枕</span></p><p><span>发帖满15篇（或曝光量满6000）</span><span>陶瓷炖盅</span></p><p><br></p><h3><span>（三）奖品领取</span></h3><p><span>1、在小红书或抖音上发帖完成后，将帖子链接和主页带曝光量的截图转发至销支的企业微信进行登记。发帖数量满足和帖子曝光量，两个条件满足任意一个即可获得奖励。</span></p><p><span>2、奖励将于活动结束后的次月10日后的3-7个工作日结算发放，届时点进活动页面即可提现。</span></p><p><span>3、&nbsp;</span><span>奖励不可叠加，以最高奖励为准。</span></p><p><br></p><h3><span>（四）活动规则</span></h3><p><span>1、</span><span>8</span><span>月10日后进行结算时，帖子不可屏蔽、违规删除、无法展示或个人可见。</span></p><p><span>2、发帖内容需为与OK保相关的正面内容，若有恶意诋毁内容，OK保有权追究法律责任。</span></p><p><span>3、以作弊形式兑换奖品，OK保有权不发放奖励。</span></p><p><br></p><h2><span>三、活动奖励发放</span></h2><p><span>1、&nbsp;</span><span>种草达人活动奖励将在活动结束后的</span><span>次月10日后，3-7个工作日</span><span>陆续安排实物奖品邮寄。</span></p><p><span>2、&nbsp;</span><span>具体奖励以实际回访核查的真实数据为准，若被邀请账号为作弊账号，则取消邀请人奖励。情节严重者，取消活动参与资格和所有奖励。</span></p><p><br></p><h2><span>四、活动参与资格、获奖资格的取消</span></h2><p><span>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</span></p><p><span>1、不符合活动参与资格的，提供虚假个人信息和邀请信息参与活动，进行虚假注册、签约和交易的。</span></p><p><span>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</span></p><p><span>3、违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</span></p><p><br></p><h2><span>五、免责条款</span></h2><p><span>互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，OK保有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障OK保及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究OK保的责任。</span></p><p><br></p><p><span>以上奖励条件以系统记录为准，若出现刷量或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。</span></p><p><br></p>'
    };
  },

  methods: {
    // 获取user状态
    getUserStatus() {
      this.$http({
        url: '/api/okbAct/actLotteryPolicyLog/queryCount',
        type: 'GET',
        data: {}
      }).then(res => {
        this.userType = res.data.userType;
        this.isSus = res.data.isSus;
      });
    },

    // 添加销售支持
    addSalesSupport() {
      if (this.$route.query.preview) return;
      this.$refs.addSalesSupportRef.open();
    },

    // 复制文案
    copyText(copywriting) {
      if (copywriting) {
        const cInput = document.createElement('input');
        cInput.value = copywriting;
        document.body.appendChild(cInput);
        // 选取文本域内容;
        cInput.select();
        document.execCommand('Copy');
        this.$notice.msg('复制成功');
        cInput.remove();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  min-height: 100vh;
  background: #f3f3f3;
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .add-sales {
      position: absolute;
      right: 0;
      left: 50%;
      bottom: 115px;
      width: 260px;
      height: 82px;
      margin-left: -130px;
      border-radius: 30px;
    }
    .rule {
      position: absolute;
      right: 0;
      top: 255px;
      width: 32px;
      height: 70px;
    }
    .copy-topic-01 {
      position: absolute;
      bottom: 320px;
      left: 295px;
      width: 110px;
      height: 32px;
    }
    .copy-topic-02 {
      position: absolute;
      bottom: 320px;
      right: 180px;
      width: 154px;
      height: 32px;
    }
    .copy-topic-03 {
      position: absolute;
      bottom: 270px;
      left: 295px;
      width: 160px;
      height: 32px;
    }
  }
}
</style>
